import LocalModal from 'components/base/local-modal';
import React, { useState } from 'react';
import { ReactComponent as LogOutIcon } from 'assets/icons/logout-icon.svg';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import useDashboardContext from 'contexts/dashboard.context';
import { handleApiError } from 'utils/functions';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  id: string;
};
const DeleteSavedAddress = ({ isOpen, onClose, id }: Props) => {
  const { refetchSavedAddressList } = useDashboardContext();

  const [loading, setLoading] = useState(false);

  const handleDeleteAddress = async () => {
    if (loading) return;
    try {
      setLoading(true);
      await apiService.delete(`user-saved-address/${id}`, {
        baseURL: process.env.REACT_APP_ORDER_API_URL
      });

      toast(<ToastMessage message='Address deleted successfully' type='success' />);
      await refetchSavedAddressList();
    } catch (error) {
      handleApiError(error);
    } finally {
      onClose();
      setLoading(false);
    }
  };
  return (
    <LocalModal isOpen={isOpen} onRequestClose={onClose} title=''>
      <div className='w-[70%] mx-auto flex flex-col justify-center items-center'>
        <LogOutIcon className='mb-4' />
        <p className='text-gray-10'>Delete Address</p>
        <p className='text-[#6F7376] text-sm'>This will remove this address from your list</p>
        <div className='w-full flex justify-between'>
          <Button
            variant='block'
            color='gray'
            className='mt-8 h-[41px] w-[139px] !bg-[#F2F2F2] !border-[#F2F2F2] !text-[#2E3031]'
            onClick={() => onClose()}>
            Cancel
          </Button>
          <Button
            variant='block'
            color='primary'
            className='mt-8 h-[41px] w-[139px]'
            loading={loading}
            onClick={handleDeleteAddress}>
            Confirm
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default DeleteSavedAddress;
